import { gql } from '@efficiently/client-core-graphql-models';

export const PROJECT_DESIGN_CHANGE_ITEM_FIELDS = gql(`
	fragment ProjectDesignChangeItem on ProjectDesignChangeItem {
		_id
		projectFinishId
		type
		action
		beforeItemId
		afterItemId
		vendorLabel
		bidLabel
		isOverridden
		createdBy {
			_id
			firstName
			lastName
		}
	}
`);
